import { render, staticRenderFns } from "./ModalRedeemError.vue?vue&type=template&id=65694f0a&scoped=true"
import script from "./ModalRedeemError.vue?vue&type=script&lang=js"
export * from "./ModalRedeemError.vue?vue&type=script&lang=js"
import style0 from "./ModalRedeemError.vue?vue&type=style&index=0&id=65694f0a&prod&rel=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65694f0a",
  null
  
)

export default component.exports